module.exports = __webpack_public_path__ + "static/media/4.8646d1f6.jpg";